import React from 'react';
import { connect } from 'react-redux';
import Divider from '@material-ui/core/Divider';
import Slide from '@material-ui/core/Slide';
import Collapse from '@material-ui/core/Collapse';

import MainCardHeader from './mainCardHeader.js'
import ProjectName from './projectName.js'

import TabsMenu from './tabsMenu/tabsMenu.js';
import BuildingLoadSwitch from './buildingLoadSwitch.js';

class MainCard extends React.Component {
    render() {
        return(
            <Slide in={!this.props.itemsSwitch && !this.props.popUpMenu.show} direction='right'>
                <div className="main-card-layout card-color">
                    <MainCardHeader/>
                    <ProjectName/>
                    <Collapse in={this.props.menu}>
                        <Divider className="divider" variant="middle"/>
                        <BuildingLoadSwitch/>
                        <Divider className="divider" variant="middle"/>
                        <TabsMenu/>
                    </Collapse>
                </div>
            </Slide>
        );
    } 
}

function mapStateToProps( state ){
    return { 
        menu: state.switches.menu,
        popUpMenu : state.popUpMenu,
        itemsSwitch : state.switches.items
    }
}

export default connect(mapStateToProps)(MainCard);